<template>
  <!-- 0411 el-select, el-input에 max-width: 70px 일괄 추가 -->
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box title-h3">
        계정 보안 정책
      </div>
      <div>
        <el-button type="primary" size="medium" style="margin-right: 5px;" :disabled="!(changeFlagLogin || changeFlagPwd || changeFlagAcc)" @click="saveAccountSecurityPolicyInfo">저장</el-button>
        <el-button size="medium" @click="onResetButtonClick" :disabled="!(changeFlagLogin || changeFlagPwd || changeFlagAcc)">취소</el-button>
      </div>
    </el-row>
    <hr class="mr-b20">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="mr-b30">
          <div class="title-h4 title-bar dot-title">로그인 정책</div>
          <div class="list form-list" v-loading="loading.login">
            <el-form ref="loginPolicyForm" :model="loginPolicyFormData" label-position="left" label-width="30%">
              <el-form-item label="로그인 정책 사용 여부" v-if="!loginPolicy">
                <el-switch v-model="loginPolicyFormData.SETLOGINPOLICY" @change="checkChangeFlag('loginpolicy')"></el-switch>
              </el-form-item>
              <el-form-item label="패스워드 오류로 인한 계정잠금 사용여부">
                <el-switch :disabled="!useLoginPolicy" v-model="loginPolicyFormData.USE_LOGINFAILCOUNT" @change="checkChangeFlag('loginpolicy')"></el-switch>
                <el-select style="max-width: 70px" :disabled="!useLoginPolicy || !loginPolicyFormData.USE_LOGINFAILCOUNT" v-model="loginPolicyFormData.LOGINFAILCOUNT" @change="checkChangeFlag('loginpolicy')">
                  <el-option v-for="item in loginFailCountData" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span>회 이상 실패 시 계정 잠금</span>
              </el-form-item>
              <el-form-item label="계정잠금 자동 해제 시간 사용 여부">
                <el-switch :disabled="!useLoginPolicy" v-model="useAutoUnlock"></el-switch>
                <el-select style="max-width: 70px" :disabled="!useLoginPolicy || !useAutoUnlock" v-model="loginPolicyFormData.PERIODLOCKING" @change="checkChangeFlag('loginpolicy')">
                  <el-option v-for="item in idLockingData" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span>분 이후 계정 잠금 자동 해제</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div>
          <div class="title-h4 title-bar dot-title">계정 관리자 연락처 정보</div>
          <div class="list form-list" v-loading="loading.contact">
            <el-form :model="accountInfoForm" label-position="left" label-width="30%">
              <el-form-item label="계정 관리자 E-Mail">
                <el-input ref="adminAddressRef" v-model="accountInfoForm.ADMINEMAILADDRESS" @change="checkChangeFlag"></el-input>
              </el-form-item>
              <el-form-item label="계정 관리자 전화번호">
                <el-input v-model="accountInfoForm.ADMINPHONENUMBER" @change="checkChangeFlag"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="title-h4 title-bar dot-title">패스워드 정책</div>
        <div class="list form-list" v-loading="loading.password">
          <el-form :model="pwdPolicyFormData" label-position="left">
            <el-form-item label="패스워드 변경방식">
              <el-select v-model="loginPolicyFormData.PASSWORDCHANGINGTYPE" @change="checkChangeFlag('loginpolicy')">
                <el-option v-for="item in pwdChangeTypeData" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="패스워드 정책 사용 여부">
              <el-switch v-model="pwdPolicyFormData.SETPASSWORDPOLICY" @change="checkChangeFlag('pwdpolicy')"></el-switch>
            </el-form-item>
            <el-form-item :disabled="!usePasswordPolicy" label="패스워드 최소 길이 제한">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.USE_MINIMUMLENGTH" @change="checkChangeFlag('pwdpolicy')"></el-switch>
              <el-select style="max-width: 70px" :disabled="!usePasswordPolicy || !pwdPolicyFormData.USE_MINIMUMLENGTH" v-model="pwdPolicyFormData.MINIMUMLENGTH" @change="checkChangeFlag('pwdpolicy')">
                <el-option v-for="item in pwdMinimum" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span>자 이상 필수 입력</span>
            </el-form-item>
            <el-form-item label="패스워드 최대 길이 제한">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.USE_MAXIMUMLENGTH" @change="checkChangeFlag('pwdpolicy')"></el-switch>
              <el-select style="max-width: 70px" :disabled="!usePasswordPolicy || !pwdPolicyFormData.USE_MAXIMUMLENGTH" v-model="pwdPolicyFormData.MAXIMUMLENGTH" @change="checkChangeFlag('pwdpolicy')">
                <el-option v-for="item in pwdMinimum" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span>자 이내로 입력</span>
            </el-form-item>
            <el-form-item label="패스워드 보안 취약패턴 체크">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.SECURITYWEAKPATTERNCHECK" @change="checkChangeFlag('pwdpolicy')"></el-switch>
              <span>(123, abc 등 연속된 세글자 포함 및 asdf, admin, root 등)</span>
            </el-form-item>
            <el-form-item label="패스워드 문자/숫자 조합 필수 여부">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.COMBINATIONCHECK" @change="checkChangeFlag('pwdpolicy')"></el-switch>
            </el-form-item>
            <el-form-item label="패스워드 특수문자 허용 여부">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.ALLOWSPECIALCHARACTER" @change="checkChangeFlag('pwdpolicy')"></el-switch>
            </el-form-item>
            <el-form-item label="패스워드 내 아이디 포함 가능 여부">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.ALLOWPASSWORDIDDUPLICATE" @change="checkChangeFlag('pwdpolicy')"></el-switch>
            </el-form-item>
            <el-form-item label="패스워드 내 개인 정보 포함 가능 여부">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.ALLOWPRIVATEINFO" @change="checkChangeFlag('pwdpolicy')"></el-switch>
              <span>(전화번호, 사번)</span>
            </el-form-item>
            <el-form-item label="패스워드 변경권고 사용">
              <el-switch :disabled="!usePasswordPolicy" v-model="pwdPolicyFormData.USE_CHANGEADVISORYPERIOD" @change="checkChangeFlag('pwdpolicy')"></el-switch>
              <el-input @input="onCheckNumber('CHANGEADVISORYPERIOD')" :disabled="!usePasswordPolicy || !pwdPolicyFormData.USE_CHANGEADVISORYPERIOD" style="max-width: 70px" v-model="pwdPolicyFormData.CHANGEADVISORYPERIOD"></el-input>
              <span>일 초과 시 변경 권고</span>
            </el-form-item>
            <el-form-item label="패스워드 필수변경 사용">
              <el-switch :disabled="!usePasswordPolicy" @change="checkChangeFlag('pwdpolicy')" v-model="pwdPolicyFormData.USE_CHANGEFORCERPERIOD"></el-switch>
              <el-input @input="onCheckNumber('CHANGEFORCERPERIOD')" :disabled="!usePasswordPolicy || !pwdPolicyFormData.USE_CHANGEFORCERPERIOD" style="max-width: 70px" v-model="pwdPolicyFormData.CHANGEFORCERPERIOD"></el-input>
              <span>일마다 패스워드 변경</span>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</w-settings-content-template>
</template>

<script>
import msgUtil from '@/utils/message';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import { cloneDeep, forEach, clone, isObject, isEqual, transform } from 'lodash';
import AccountSecurityPolicyApi from '@/api/settings/user/account-security-policy';
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import { mapState } from 'vuex';

export default {
  name: 'WAccountSecurityPolicy',
  components: {
    WSettingsContentTemplate,
  },
  data() {
    return {
      formData: {
        setLockingForErrorSwitch: false,
      },
      loading: {
        login: false,
        password: false,
        contact: false,
      },
      loginFailCountSelected: 1,
      loginFailCountData: [1, 2, 3, 4, 5],
      idLockingData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      loginPolicyFormData: {},
      lockingForErrorCountFlag: 0,
      useAutoUnlock: 0,
      pwdPolicyFormData: {},
      pwdMinimumFlag: 0,
      pwdMinimum: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      pwdMaximumFlag: 0,
      accountInfoForm: {},
      pwdChangeTypeData: [
        {
          label: '관리자가 직접변경',
          value: 'PASSWORDDIRECTCHANGE',
        },
        {
          label: '초기화 패스워드 메일전송',
          value: 'PASSWORDINIT',
        },
      ],
      loginPolicyOriginData: {},
      pwdPolicyOriginData: {},
      changeFlagLogin: false,
      changeFlagPwd: false,
      changeFlagAcc: false,
    };
  },
  computed: {
    ...mapState({ loginPolicy: (state) => state.user.userInfo.loginPolicy }),
    /**
     * 로그인 정책 사용 여부
     * @author Ju
     * @return {[type]} [description]
     */
    useLoginPolicy() {
      return this.loginPolicyFormData.SETLOGINPOLICY;
    },
    /**
     * 패스워드 변경 사용 여부
     * @author Ju
     * @return {[type]} [description]
     */
    usePasswordPolicy() {
      return this.pwdPolicyFormData.SETPASSWORDPOLICY;
    },
  },
  watch: {
    useAutoUnlock: {
      handler(val) {
        this.changeAutoUnlock(val);
      },
    },
    'pwdPolicyFormData.MINIMUMLENGTH': {
      handler(to) {
        const maximumLength = this.pwdPolicyFormData.MAXIMUMLENGTH;
        if (to > maximumLength) {
          this.pwdPolicyFormData.MAXIMUMLENGTH = to;
        }
      },
    },
    'pwdPolicyFormData.MAXIMUMLENGTH': {
      handler(to) {
        const minimumLength = this.pwdPolicyFormData.MINIMUMLENGTH;
        if (to < minimumLength) {
          this.pwdPolicyFormData.MINIMUMLENGTH = to;
        }
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 계정 보안 정책 정보를 로드한다.
     * @return {[type]} [description]
     */
    loadData() {
      // 로그인 정책
      this.loading.login = true;
      basicinfoSetAPI
        .getList('loginpolicy')
        .then((response) => {
          if (response.data.success) {
            const loginPolicyList = response.data.data;
            const policyObj = this.convertToPolicyObj(loginPolicyList);
            this.loginPolicyFormData = this.convertStringToBool(policyObj);
            this.setUseAutoUnlockByLockingType(policyObj.IDLOCKINGTYPE);
            this.loginPolicyOriginData = clone(this.loginPolicyFormData);
            this.changeFlagLogin = false;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그인 정책 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그인 정책 정보', false));
        })
        .finally(() => {
          this.loading.login = false;
        });

      // 패스워드 정책
      this.loading.password = true;
      basicinfoSetAPI
        .getList('passwordpolicy')
        .then((response) => {
          if (response.data.success) {
            const passwordpolicy = response.data.data;
            const policyObj = this.convertToPolicyObj(passwordpolicy);
            this.pwdPolicyFormData = this.convertStringToBool(policyObj);
            this.pwdPolicyOriginData = clone(this.pwdPolicyFormData);
            this.changeFlagPwd = false;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '패스워드 정책 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '패스워드 정책 정보', false));
        })
        .finally(() => {
          this.loading.password = false;
        });

      // 계정 관리자 연락처 정보
      this.loading.contact = true;
      basicinfoSetAPI
        .getList('sdsetting')
        .then((response) => {
          if (response.data.success) {
            const passwordpolicy = response.data.data;
            const policyObj = this.convertToPolicyObj(passwordpolicy);
            this.accountInfoForm = policyObj;
            this.accountInfoOriginData = clone(this.accountInfoForm);
            this.changeFlagAcc = false;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정 관리자 연락처 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정 관리자 연락처 정보', false));
        })
        .finally(() => {
          this.loading.contact = false;
        });
    },
    /**
     * 계정 보안 정책 기준정보 배열을 Object 형태로 가공하여 반환한다.
     * @param  {[type]} policyList [description]
     * @return {[type]}            [description]
     */
    convertToPolicyObj(policyList) {
      const policyObj = {};
      forEach(policyList, (policy) => {
        if (policy.datatypeId === 'BOOL') {
          policyObj[policy.basicinfoSubid] = policy.basicinfoSubvalueBoolean;
        } else if (policy.datatypeId === 'INTEGER') {
          policyObj[policy.basicinfoSubid] = policy.basicinfoSubvalueInteger;
        } else if (policy.datatypeId === 'STRING') {
          policyObj[policy.basicinfoSubid] = policy.basicinfoSubvalueString;
        }
      });
      return policyObj;
    },
    /**
     * 계정 잠금 자동 해제 시간 여부 설정 값에 따라 플래그 값을 설정한다.
     * KEEPGOINGLOCKING: 자동 해제 미 사용
     * PERIODLOCKING: 자동 해제 사용
     * @author Ju
     * @param  {[type]} lockingType [description]
     */
    setUseAutoUnlockByLockingType(lockingType) {
      this.useAutoUnlock = lockingType !== 'KEEPGOINGLOCKING';
    },
    /**
     * 값이 숫자인지 확인한다.
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    onCheckNumber(target) {
      const value = this.pwdPolicyFormData[target];
      if (value === '' || isNaN(Number(value))) {
        this.pwdPolicyFormData[target] = 0;
      } else {
        this.pwdPolicyFormData[target] = Number(value);
      }
      this.changeFlagPwd = !isEqual(this.pwdPolicyFormData, this.pwdPolicyOriginData);
    },
    /**
     * 수정된 계정 보안 정책 정보를 저장한다.
     * @return {[type]} [description]
     */
    saveAccountSecurityPolicyInfo() {
      // 전달 파라미터 세팅
      const targetForm = {
        loginpolicy: this.difference(this.loginPolicyFormData, this.loginPolicyOriginData),
        passwordpolicy: this.difference(this.pwdPolicyFormData, this.pwdPolicyOriginData),
        sdsetting: this.difference(this.accountInfoForm, this.accountInfoOriginData),
      };

      const target = '계정 보안 정책';
      const action = msgUtil.action.SAVE;
      AccountSecurityPolicyApi.setAccountSecurityPolicy(targetForm)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    /**
     * 계정 보안 정책 정보 변경 여부를 확인한다.
     * @param  {[type]} policyType [description]
     * @return {[type]}            [description]
     */
    checkChangeFlag(policyType) {
      if (policyType === 'loginpolicy') {
        this.changeFlagLogin = !isEqual(this.loginPolicyFormData, this.loginPolicyOriginData);
      } else if (policyType === 'pwdpolicy') {
        this.changeFlagPwd = !isEqual(this.pwdPolicyFormData, this.pwdPolicyOriginData);
      } else {
        this.changeFlagAcc = !isEqual(this.accountInfoForm, this.accountInfoOriginData);
      }
    },
    /**
     * 취소 버튼 이벤트 클릭 핸들러
     */
    onResetButtonClick() {
      this.loginPolicyFormData = cloneDeep(this.loginPolicyOriginData);
      this.setUseAutoUnlockByLockingType(this.loginPolicyFormData.IDLOCKINGTYPE);
      this.pwdPolicyFormData = cloneDeep(this.pwdPolicyOriginData);
      this.accountInfoForm = clone(this.accountInfoOriginData);
      this.checkChangeFlag('loginpolicy');
      this.checkChangeFlag('pwdpolicy');
      this.checkChangeFlag();
    },
    /**
     * 수정된 계정 잠금 자동 해제 시간 사용 여부 변경 값을 설정한다.
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    changeAutoUnlock(value) {
      if (value) {
        this.loginPolicyFormData.IDLOCKINGTYPE = 'PERIODLOCKING';
      } else {
        this.loginPolicyFormData.IDLOCKINGTYPE = 'KEEPGOINGLOCKING';
      }
      this.checkChangeFlag('loginpolicy');
    },
    /**
     * 두개의 Object를 비교하여 기준과 값이 다른 대상들을 포함하는 새로운 Object변수를 생성하는 함수
     * @param  {[type]} object [description]
     * @param  {[type]} base   [description]
     * @return {[type]}        [description]
     */
    difference(object, base) {
      return transform(object, (result, value, key) => {
        if (!isEqual(value, base[key])) {
          result[key] = isObject(value) && isObject(base[key]) ? this.difference(value, base[key]) : value;
        }
      });
    },
    /**
     * Basicinfo에서 value가 문자열 1,0으로 넘어오는 bool타입 대상이 있다. 해당 값을 True, False로 변환시켜 사용하기 위한 변환 함수
     * @param  {[type]} targetObject [description]
     * @return {[type]}              [description]
     */
    convertStringToBool(targetObject) {
      return transform(targetObject, (result, value, key) => {
        // 값에 대한 것은 Integer로 넘어온다. Bool은 1,0으로 오며 String형(더블 쿼텐션)이다.
        // 추후 String형 데이터가 넘어 올 시 해당 코드는 수정이 필요하다. (현재 대상 값은 Integer, Bool은 '1','0' 두개 사용 중, String은 연락처, email만 해당)
        if (value === '1') {
          result[key] = true;
        } else if (value === '0') {
          result[key] = false;
        } else {
          result[key] = value;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/AccountSecurityPolicy/index.vue